import image01 from "../images/sponsors/01.png";
import image02 from "../images/sponsors/02.png";
import image03 from "../images/sponsors/03.png";
import image04 from "../images/sponsors/04.png";
import image05 from "../images/sponsors/05.png";
import image06 from "../images/sponsors/06.png";
import image07 from "../images/sponsors/07.png";
import image08 from "../images/sponsors/08.png";
import image09 from "../images/sponsors/09.png";
import image10 from "../images/sponsors/10.png";
import image11 from "../images/sponsors/11.png";
import image12 from "../images/sponsors/12.png";
import image13 from "../images/sponsors/13.png";
import image14 from "../images/sponsors/14.png";
import image15 from "../images/sponsors/15.png";
import image16 from "../images/sponsors/16.png";
import image17 from "../images/sponsors/17.png";
import image18 from "../images/sponsors/18.png";
import image19 from "../images/sponsors/19.png";
import image20 from "../images/sponsors/20.png";
import image21 from "../images/sponsors/21.png";
import image22 from "../images/sponsors/22.png";
import image23 from "../images/sponsors/23.png";
import image24 from "../images/sponsors/24.png";
import image25 from "../images/sponsors/25.png";
import image26 from "../images/sponsors/26.png";
import image27 from "../images/sponsors/27.png";
import image28 from "../images/sponsors/28.png";
import image29 from "../images/sponsors/29.png";
import image30 from "../images/sponsors/30.png";
import image31 from "../images/sponsors/31.png";
import image32 from "../images/sponsors/32.png";
import image33 from "../images/sponsors/33.png";
import image34 from "../images/sponsors/34.png";
import image35 from "../images/sponsors/35.png";
import image36 from "../images/sponsors/36.png";
import image37 from "../images/sponsors/37.png";
import image38 from "../images/sponsors/38.png";
import image39 from "../images/sponsors/39.png";
import image40 from "../images/sponsors/40.png";
import image41 from "../images/sponsors/41.png";
import image42 from "../images/sponsors/42.png";
import image43 from "../images/sponsors/43.png";
import image44 from "../images/sponsors/44.png";
import image45 from "../images/sponsors/45.png";
import image46 from "../images/sponsors/46.png";
import image47 from "../images/sponsors/47.png";
import image48 from "../images/sponsors/48.png";
import image49 from "../images/sponsors/49.png";
import image50 from "../images/sponsors/50.png";
import image51 from "../images/sponsors/51.png";
import image52 from "../images/sponsors/52.png";
import image53 from "../images/sponsors/53.png";
import image54 from "../images/sponsors/54.png";
import image55 from "../images/sponsors/55.png";
import image56 from "../images/sponsors/56.png";
import image57 from "../images/sponsors/57.png";
import image58 from "../images/sponsors/58.png";
import image59 from "../images/sponsors/59.png";
import image60 from "../images/sponsors/60.png";
import image61 from "../images/sponsors/61.png";
import image62 from "../images/sponsors/62.png";
import image63 from "../images/sponsors/63.png";
import image64 from "../images/sponsors/64.png";
import image65 from "../images/sponsors/65.png";
import image66 from "../images/sponsors/66.png";
import image67 from "../images/sponsors/67.png";
import image68 from "../images/sponsors/68.png";
import image69 from "../images/sponsors/69.png";
import image70 from "../images/sponsors/70.png";
import image71 from "../images/sponsors/71.png";
import image72 from "../images/sponsors/72.png";
import image73 from "../images/sponsors/73.png";
import image74 from "../images/sponsors/74.png";
import image75 from "../images/sponsors/75.png";
import image76 from "../images/sponsors/76.png";
import image77 from "../images/sponsors/77.png";
import image78 from "../images/sponsors/78.png";
import image79 from "../images/sponsors/79.png";
import image80 from "../images/sponsors/80.png";
import image81 from "../images/sponsors/81.png";
import image82 from "../images/sponsors/82.png";
import image83 from "../images/sponsors/83.png";
import image84 from "../images/sponsors/84.png";
import image85 from "../images/sponsors/85.png";
import image86 from "../images/sponsors/86.png";
import image87 from "../images/sponsors/87.png";

export const sponsorsData = [
  { image: image01 },
  { image: image02 },
  { image: image03 },
  { image: image04 },
  { image: image05 },
  { image: image06 },
  { image: image07 },
  { image: image08 },
  { image: image09 },
  { image: image10 },
  { image: image11 },
  { image: image12 },
  { image: image13 },
  { image: image14 },
  { image: image15 },
  { image: image16 },
  { image: image17 },
  { image: image18 },
  { image: image19 },
  { image: image20 },
  { image: image21 },
  { image: image22 },
  { image: image23 },
  { image: image24 },
  { image: image25 },
  { image: image26 },
  { image: image27 },
  { image: image28 },
  { image: image29 },
  { image: image30 },
  { image: image31 },
  { image: image32 },
  { image: image33 },
  { image: image34 },
  { image: image35 },
  { image: image36 },
  { image: image37 },
  { image: image38 },
  { image: image39 },
  { image: image40 },
  { image: image41 },
  { image: image42 },
  { image: image43 },
  { image: image44 },
  { image: image45 },
  { image: image46 },
  { image: image47 },
  { image: image48 },
  { image: image49 },
  { image: image50 },
  { image: image51 },
  { image: image52 },
  { image: image53 },
  { image: image54 },
  { image: image55 },
  { image: image56 },
  { image: image57 },
  { image: image58 },
  { image: image59 },
  { image: image60 },
  { image: image61 },
  { image: image62 },
  { image: image63 },
  { image: image64 },
  { image: image65 },
  { image: image66 },
  { image: image67 },
  { image: image68 },
  { image: image69 },
  { image: image70 },
  { image: image71 },
  { image: image72 },
  { image: image73 },
  { image: image74 },
  { image: image75 },
  { image: image76 },
  { image: image77 },
  { image: image78 },
  { image: image79 },
  { image: image80 },
  { image: image81 },
  { image: image82 },
  { image: image83 },
  { image: image84 },
  { image: image85 },
  { image: image86 },
  { image: image87 },
];
